import { useState } from "react";
import { AlertCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "../../lib/lang";
import { FULL_MENU } from "../../lib/content";
import { DishCard, DishLightbox, CARD_ROW } from "./MezzeShowcase";
import { LunchStudent } from "./LunchStudent";

export const MenuBento = () => {
  const { t, lang } = useLang();
  const [cat, setCat] = useState(FULL_MENU[0].id);
  const [zoom, setZoom] = useState(null);
  const active = FULL_MENU.find((c) => c.id === cat);
  const photoItems = active.items.filter((it) => it[2]);
  const textItems = active.items.filter((it) => !it[2]);
  return (
    <section id="menu" data-testid="menu-section" className="bg-transparent pb-24 lg:pb-36">
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
        <LunchStudent />

        <Reveal data-testid="full-menu-section" className="rounded-[32px] bg-[#FBF1E6]/85 px-5 py-14 ring-1 ring-[#A9493B]/15 backdrop-blur-md sm:px-10 lg:py-20">
          <p className="eyebrow text-[#721121]">{t.menu.eyebrow}</p>
          <h3 className="font-display mt-4 text-4xl leading-[0.95] tracking-tight text-[#1C1917] sm:text-5xl">{t.menu.full}</h3>
          <div data-lenis-prevent-touch className="-mx-5 mt-8 flex gap-2 overflow-x-auto px-5 pb-2 sm:-mx-10 sm:px-10 lg:mx-0 lg:flex-wrap lg:px-0">
            {FULL_MENU.map((c) => (
              <button
                key={c.id}
                data-testid={`menu-category-tab-${c.id}`}
                onClick={() => setCat(c.id)}
                className={`shrink-0 rounded-full px-5 py-2.5 text-sm transition-colors duration-300 ${cat === c.id ? "bg-[#721121] text-white" : "bg-white text-[#1C1917] ring-1 ring-[#721121]/15 hover:text-[#721121]"}`}
              >
                {c.name[lang]}
              </button>
            ))}
          </div>
          {photoItems.length > 0 && (
            <div key={cat} data-testid="full-menu-list" data-lenis-prevent-touch className={`${CARD_ROW} lg:grid-cols-5 lg:gap-x-5 lg:gap-y-10`}>
              {photoItems.map(([n, p, thumb, desc], idx) => (
                <DishCard
                  key={n}
                  i={idx % 4}
                  animateOnMount
                  testId={`menu-card-${thumb.split("/")[1]}-${idx}`}
                  name={n}
                  price={p}
                  desc={desc?.[lang]}
                  src={`/${thumb}-lg.webp`}
                  onOpen={() => setZoom({ name: n, price: p, desc: desc?.[lang], src: `/${thumb}-lg.webp` })}
                />
              ))}
            </div>
          )}
          {textItems.length > 0 && (
            <ul data-testid="full-menu-text-list" className="mt-10 grid gap-x-10 sm:grid-cols-2">
              {textItems.map(([n, p]) => (
                <li key={n} className="flex items-baseline gap-3 border-b border-dashed border-[#721121]/20 py-3">
                  <span className="text-[15px] text-[#1C1917]">{n}</span>
                  <span className="flex-1" />
                  <span className="font-display text-xl font-semibold text-[#721121]">{p} kr</span>
                </li>
              ))}
            </ul>
          )}
          <DishLightbox dish={zoom} onClose={() => setZoom(null)} />
          <p className="mt-8 flex items-center gap-2 text-sm text-[#57534E]"><AlertCircle size={16} className="text-[#721121]" /> {t.menu.allergy}</p>
        </Reveal>
      </div>
    </section>
  );
};
